import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["strict", "value", "step", "min", "max", "precision", "onValueChange", "format", "parse", "withInput", "disabled", "invalid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { RegionProvider, useSimpleRegion } from '@tencent/glue-react-region';
import React, { memo } from 'react';
import { InputNumberContent } from '../InputNumber/InputNumberContent';
import { ViewSlider } from '../../views/ViewSlider';
import { SliderContent } from './SliderContent';
export var Slider = memo(function (props) {
  var strict = props.strict,
      value = props.value,
      step = props.step,
      min = props.min,
      max = props.max,
      precision = props.precision,
      onValueChange = props.onValueChange,
      format = props.format,
      parse = props.parse,
      _props$withInput = props.withInput,
      withInput = _props$withInput === void 0 ? false : _props$withInput,
      disabled = props.disabled,
      invalid = props.invalid,
      extra = _objectWithoutProperties(props, _excluded);

  var _useSimpleRegion = useSimpleRegion({
    strict: strict,
    value: value,
    step: step,
    min: min,
    max: max,
    precision: precision
  }, onValueChange),
      _useSimpleRegion2 = _slicedToArray(_useSimpleRegion, 2),
      region = _useSimpleRegion2[0],
      end = _useSimpleRegion2[1];

  return React.createElement(RegionProvider, {
    value: region
  }, React.createElement(ViewSlider, _objectSpread(_objectSpread({}, extra), {}, {
    withInput: withInput,
    input: withInput && React.createElement(InputNumberContent, {
      simple: true,
      disabled: disabled,
      format: format,
      parse: parse
    })
  }), React.createElement(SliderContent, {
    format: format,
    disabled: disabled,
    showStart: false,
    invalid: invalid,
    rangeStart: 0,
    rangeEnd: end
  })));
});